import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { ResourceCommands } from './domain/resource-commands';
import { ResourceEventProvider } from './events/resource-event.provider';
import { ResourceRepository } from './repositories/resource.repository';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ResourceRepository],
})
export class ResourceModule {
  static forRoot(): ModuleWithProviders<ResourceModule> {
    return {
      ngModule: ResourceModule,
      providers: [
        {
          provide: ResourceEventProvider,
        },
        {
          provide: ResourceCommands,
        },
      ],
    };
  }
}
